<template>
  <div :class="containerClasses">
    <vue-monthly-picker ref="picker" v-model="value" :monthLabels="monthLabels" :dateFormat="dateFormat"
                        class="form-control-month" @input="updated" >
    </vue-monthly-picker>
  </div>
</template>

<style lang="scss">
.form-control-month {
  display: block !important;
  width: 100% !important;
  height: calc(1.5em + 0.75rem + 2px) !important;
  padding: 0 !important;
  font-size: 1rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #495057 !important;
  background-color: #fff !important;
  background-clip: padding-box !important;
  border: 1px solid #ced4da !important;
  border-radius: 0.125rem !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}
.vue-monthly-picker .input {
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}
</style>

<script>
  import VueMonthlyPicker from 'vue-monthly-picker'
  import qs from 'qs'
  import moment from 'moment/moment'

  export default {
    name: 'o-filter-monthpicker',
    props: {
      title: {
        type: String,
        required: true
      },
      column: {
        type: String,
        required: false
      },
      classes: {
        type: String,
        default: ''
      },
      dateFormat: {
        type: String,
        default: 'MMMM YYYY'
      },
      dayOfTheMonth: {
        type: String,
        default: 'first'
      }
    },

    data: () => ({
      containerClasses: '',
      value: '',
      monthLabels: []
    }),

    methods: {
      updated() {
        this.enableFilter()
      },
      enableFilter() {
        this.$parent.$emit('enable-filter', {
          column: this.column ? this.column : this.title,
          title: this.title,
          value: moment(this.value).startOf('month').format('YYYY-MM'),
          displayValue: moment(this.value).startOf('month').format('YYYY-MM')
        })
        this.value = ''
      },
      checkUrlFilter() {
        // check url hash to see if we have a filter in the uri
        if (!document.location.search) {
          return
        }
        var params = qs.parse(document.location.search.substr(1))

        if (this.column in params.filter) {
          this.$parent.$emit('enable-filter', {
            column: this.column ? this.column : this.title,
            title: this.title,
            value: params.filter[this.column],
            displayValue: params.filter[this.column]
          })
        }
      }
    },
    components: {
      VueMonthlyPicker
    },
    mounted() {
      this.monthLabels = [
        this.$i18n.t('core.january_long'),
        this.$i18n.t('core.february_long'),
        this.$i18n.t('core.march_long'),
        this.$i18n.t('core.april_long'),
        this.$i18n.t('core.may_long'),
        this.$i18n.t('core.june_long'),
        this.$i18n.t('core.july_long'),
        this.$i18n.t('core.august_long'),
        this.$i18n.t('core.september_long'),
        this.$i18n.t('core.october_long'),
        this.$i18n.t('core.november_long'),
        this.$i18n.t('core.december_long')
      ]
      this.$on('set-classes', (classes) => {
        this.containerClasses = classes
      })
      this.checkUrlFilter()
    }
  }
</script>
